import * as React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionsCreators } from "../../../actions";
import strings from "../../../helpers/Localization";
import { toast } from "react-toastify";
import cloneDeep from "lodash/cloneDeep";

//MUI ELEMENTS
import {
    Tooltip,
    Paper,
    TextField,
    Button,
    FormControlLabel,
    Checkbox,
    Typography,
    MenuItem,
    Fab,
    Stack,
    Divider,
    IconButton
} from "@mui/material";

import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";

import ParseQuery from "../../../helpers/ParseQueryString";
import { findNode } from "../../../helpers/TreeHelper";
import Loader from "../../../aGlobalDesign/Loader/Loader";
import PageMetaHelmet from "../../../aGlobalDesign/PageMetaHelmet/PageMetaHelmet";

const types = [
    {
        key: 0,
        value: strings.string
    },
    {
        key: 1,
        value: strings.int
    },
    {
        key: 2,
        value: strings.dateTime
    },
    {
        key: 3,
        value: strings.content
    },
    {
        key: 4,
        value: strings.urlOrganization
    },
    {
        key: 5,
        value: strings.FormOrganization
    },
    {
        key: 6,
        value: strings.textOrganization
    },
    {
        key: 7,
        value: strings.tableOrganization
    }
];
class Organization extends React.Component {

    constructor(props) {
        super(props);
        const id = ParseQuery(props.location.search).id || null;
        const isDuplicate = ParseQuery(props.location.search).duplicate || false;
        this.state = {
            isLoaded: false,
            isDuplicate: isDuplicate,
            duplicateId: id,
            organizationId: isDuplicate ? null : id,
            organizationName: "",
            errorName: false,

            listEmails: [{ displayName: "", email: "" }],
            listLanguages: [{
                name: "",
                code: "",
                checkedByDefault: true
            }],
            isDisabled: false,

            compDescription: true,
            compDescription2: false,
            compIsVisible: true,
            compPreview: true,

            compositionTree: [],
            compositionParameters: [{
                key: "",
                value: "",
                type: 0,
                isRequired: false
            }],
            selectedItem: null,
            selectedItemId: null,

            organizationParameters: [{
                key: "",
                value: ""
            }],

            displayParameters: [{
                key: "",
                defaultValue: ""
            }],

            organizationFiles: [{
                key: "",
                value: "",
                file: null
            }],

            currentFileIndex: null,
            maximumNumberOfDisplays: 0,
            compositionModules: ""
        };
    }

    componentDidMount() {
        this.props.changeAppBarTitle(strings.titleOrg);
        if (this.state.organizationId || this.state.isDuplicate) {
            const orgId = this.state.organizationId || this.state.duplicateId;
            this.props.GetOrganizationAdmin(orgId, (org) => {
                console.log(org);
                const config = JSON.parse(org.compositionConfiguration);
                const languages = org.languages ? org.languages : [];
                languages.push({
                    name: "",
                    code: "",
                    checkedByDefault: true
                });

                const compositionData = JSON.parse(org.defaultCompositionData);
                const parameters = compositionData.parameters ? compositionData.parameters : [];
                parameters.push({
                    key: "",
                    value: "",
                    type: 0
                });

                const orgParam = org.organizationParameters ? org.organizationParameters : [];
                orgParam.push({
                    key: "",
                    value: ""
                });

                const displayParam = org.displayParameters ? JSON.parse(org.displayParameters) : [];
                displayParam.push({
                    key: "",
                    defaultValue: ""
                });

                this.setState({
                    organizationName: org.name,
                    isDisabled: org.isDisabled,
                    listLanguages: languages,
                    compositionTree: compositionData.compositionTree,
                    compDescription: config.description,
                    compDescription2: config.description2 || false,
                    compIsVisible: config.isVisible,
                    compPreview: config.preview,
                    compositionParameters: parameters,
                    organizationParameters: orgParam,
                    maximumNumberOfDisplays: org.maximumNumberOfDisplays,
                    compositionModules: org.compositionModules,
                    isLoaded: true,
                    displayParameters: displayParam
                });
            });
        }
    }

    //#region Tree
    getSelectedItem(itemId) {
        let item = null;
        if (itemId) {
            item = findNode(itemId, this.state.compositionTree);
        }
        this.setState({ selectedItem: item, selectedItemId: itemId });
    }

    onItemChange(itemId, newItemData) {
        const data = this.state.compositionTree;
        let node = findNode(itemId, data);
        node = newItemData;
        this.setState({ data });
    }
    //#endregion

    onAddEmail(event, index, item, isEmail) {
        const listEmails = this.state.listEmails;
        if (event.target.value === "" && (isEmail && item.displayName === "") || !isEmail && item.email === "") {
            listEmails.splice(index, 1);
        }
        else {
            isEmail ? listEmails[index].email = event.target.value : listEmails[index].displayName = event.target.value;
            if (index + 1 === listEmails.length) {
                listEmails.push({ email: "", displayName: "" });
            }
        }
        this.setState({ listEmails });
    }

    onEditLanguage(value, index, property) {
        const listLanguages = this.state.listLanguages;
        if (value === "" && property === "name") {
            listLanguages.splice(index, 1);
        }
        else {
            const item = listLanguages[index];
            item[property] = value;
            if (index + 1 === listLanguages.length && property === "name") {
                listLanguages.push({
                    name: "",
                    code: "",
                    checkedByDefault: true
                });
            }
        }
        this.setState({ listLanguages });
    }

    onEditParameter(value, index, property) {
        const compositionParameters = this.state.compositionParameters;
        if (value === "" && property === "key") {
            compositionParameters.splice(index, 1);
        }
        else {
            const item = compositionParameters[index];
            item[property] = value;
            // console.log(value, property);
            if (property === "type") {
                //dateTime
                if (value === 2) {
                    item.value = null;
                }
                //Content
                else if (value === 3) {
                    item.value = "";
                }
            }
            if (index + 1 === compositionParameters.length && property === "key") {
                compositionParameters.push({
                    key: "",
                    value: "",
                    type: 0,
                    isRequired: false
                });
            }
        }
        this.setState({ compositionParameters });
    }

    onEditOrgParameter(value, index, property) {
        const organizationParameters = this.state.organizationParameters;
        if (value === "" && property === "key") {
            organizationParameters.splice(index, 1);
        }
        else {
            const item = organizationParameters[index];
            item[property] = value;
            if (index + 1 === organizationParameters.length && property === "key") {
                organizationParameters.push({
                    key: "",
                    value: ""
                });
            }
        }
        this.setState({ organizationParameters });
    }

    onEditOrgFile(value, index, property) {
        const organizationFiles = this.state.organizationFiles;
        if (value === "" && property === "key") {
            organizationFiles.splice(index, 1);
        }
        else {
            const item = organizationFiles[index];
            item[property] = value;
            if (index + 1 === organizationFiles.length && property === "key") {
                organizationFiles.push({
                    key: "",
                    value: ""
                });
            }
        }
        this.setState({ organizationFiles });
    }

    handleFileChange(file) {
        const organizationFiles = this.state.organizationFiles;
        const organizationFile = this.state.organizationFiles[this.state.currentFileIndex];
        organizationFile.file = file[0];
        organizationFile.value = file[0].name;
        organizationFiles[this.state.currentFileIndex] = organizationFile;
        this.setState({ organizationFiles });
    }

    onEditDisplayParameter(value, index, property) {
        const displayParameters = this.state.displayParameters;
        if (value === "" && property === "key") {
            displayParameters.splice(index, 1);
        }
        else {
            const item = displayParameters[index];
            item[property] = value;
            if (index + 1 === displayParameters.length && property === "key") {
                displayParameters.push({
                    key: "",
                    defaultValue: ""
                });
            }
        }
        this.setState({ displayParameters });
    }

    onClose() {
        this.props.history.push("/SuperAdmin/OrganizationsList");
    }

    onSaveChange() {
        if (this.state.organizationName === "") {
            this.props.OpenDialog({
                description: strings.mustHaveOrgName,
                primaryLabel: "OK",
                clickOutsideToClose: true
            });
            return;
        }

        if (this.state.listEmails[0].email === "" && !this.state.organizationId) {
            this.props.OpenDialog({
                description: strings.mustHaveOneEmail,
                primaryLabel: "OK",
                clickOutsideToClose: true
            });
            return;
        }

        const orgFiles = cloneDeep(this.state.organizationFiles);
        orgFiles.splice(orgFiles.length - 1, 1);

        const organizationFiles = [];
        const formData = new FormData();
        orgFiles.forEach(param => {
            if (param.file !== null) {
                organizationFiles.push(param.key);
                formData.append("files", param.file);
            }
        });

        const listEmails = this.state.listEmails;
        const listValidEmails = [];
        let allValid = true;
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        listEmails.forEach(admin => {
            if (re.test(admin.email)) {
                listValidEmails.push({ email: admin.email, displayName: admin.displayName });
            }
            else if (admin.email !== "") {
                allValid = false;
            }
        });

        if (!allValid) {
            this.props.OpenDialog({
                description: strings.emailMustBe,
                primaryLabel: "OK",
                clickOutsideToClose: true
            });
            return;
        }

        const configuration = {
            isVisible: this.state.compIsVisible,
            preview: this.state.compPreview,
            description: this.state.compDescription,
            description2: this.state.compDescription2
        };

        //Remove last elements from array as it is empty
        const listLanguages = cloneDeep(this.state.listLanguages);
        listLanguages.splice(listLanguages.length - 1, 1);
        const organizationParameters = cloneDeep(this.state.organizationParameters);
        organizationParameters.splice(organizationParameters.length - 1, 1);
        const compositionParameters = cloneDeep(this.state.compositionParameters);
        compositionParameters.splice(compositionParameters.length - 1, 1);
        const displayParameters = cloneDeep(this.state.displayParameters);
        displayParameters.splice(displayParameters.length - 1, 1);

        // const compositionParameters = this.state.compositionParameters;

        let i = 0;
        compositionParameters.forEach(parameter => {
            parameter.Position = i++;
        });

        const obj = {
            name: this.state.organizationName,
            organizationAdministrators: listValidEmails,
            isDisabled: this.state.isDisabled,
            compositionConfiguration: JSON.stringify(configuration),
            languages: listLanguages,
            defaultCompositionData: JSON.stringify({
                compositionTree: this.state.compositionTree,
                parameters: compositionParameters
            }),
            organizationParameters: organizationParameters,
            organizationFiles: organizationFiles,
            maximumNumberOfDisplays: this.state.maximumNumberOfDisplays,
            compositionModules: this.state.compositionModules,
            displayParameters: JSON.stringify(displayParameters)
        };

        if (this.state.organizationId) {
            obj.id = this.state.organizationId;
            formData.append("organizationObjAsString", JSON.stringify(obj));

            this.props.EditOrganization(formData, () => {
                toast.success(strings.organizationSaved);
                this.props.history.push("/SuperAdmin/OrganizationsList");
                this.props.GetCurrentUser(() => {});
            });
        }
        else {
            formData.append("organizationObjAsString", JSON.stringify(obj));
            this.props.CreateOrganization(formData, () => {
                toast.success(strings.organizationSaved);
                this.props.history.push("/SuperAdmin/OrganizationsList");
            });
        }
    }


    render() {

        return <div className="defaultPageContent">
            <PageMetaHelmet title={strings.helmetOrg} icon={"/icons/favicon.ico"} />
            <div className="defaultPageWrapper">
                {
                    (this.state.organizationId
                    || this.state.duplicateId)
                    && this.state.isLoaded === false ?
                        <div>
                            <Loader dimensions="40px" color={"var(--primary-base)"} />
                        </div>
                        :
                        <Paper sx={{ width: "calc(100vw - 390px)", p: 2 }}>
                            <Stack spacing={2} style={{ overflow: "auto", height: "calc(100vh - 170px)" }}>
                                <Stack spacing={2} direction="row" alignItems="center">
                                    <TextField variant="standard"
                                        error={this.state.errorName}
                                        sx={{ flex: 1 }}
                                        label={strings.organizationName}
                                        value={this.state.organizationName}
                                        onChange={(e) => {
                                            this.setState({
                                                organizationName: e.target.value,
                                                errorName: e.target.value === ""
                                            });
                                        }}
                                    />
                                    <Tooltip title={strings.Save} placement="top">
                                        <div>
                                            <IconButton variant="contained"
                                                size="small"
                                                className="TopButtons"
                                                color="primary"
                                                onClick={() => this.onSaveChange()}
                                            >
                                                <SaveIcon/>
                                            </IconButton>
                                        </div>
                                    </Tooltip>
                                    <Tooltip title={strings.Close} placement="top">
                                        <div>
                                            <IconButton variant="contained"
                                                size="small"
                                                className="TopButtons"
                                                color="primary"
                                                onClick={() => this.onClose()}
                                            >
                                                <CloseIcon/>
                                            </IconButton>
                                        </div>
                                    </Tooltip>
                                </Stack>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={this.state.isDisabled}
                                            onChange={(e) => this.setState({ isDisabled: e.target.checked })}
                                            value="isDisabled"
                                            color="primary"
                                        />
                                    }
                                    label={strings.isDisabled}
                                />
                                <TextField variant="standard"
                                    sx={{ flex: 1 }}
                                    label={strings.maxDisplayNumber}
                                    value={this.state.maximumNumberOfDisplays}
                                    onChange={(e) => this.setState({ maximumNumberOfDisplays: e.target.value })}
                                    inputProps={{
                                        type: "number"
                                    }}
                                />
                                {
                                    this.state.organizationId ?
                                        null
                                        :
                                        <>
                                            {
                                                this.state.listEmails.map((item, index) => {
                                                    const indexItem = this.state.listEmails.indexOf(item);
                                                    return <Stack spacing={2} direction="row">
                                                        <TextField variant="standard"
                                                            key={indexItem + "email"}
                                                            error={index === 0 && this.state.listEmails[indexItem].email === ""}
                                                            sx={{ flex: 1 }}
                                                            label={strings.organizationAdminEmail}
                                                            value={this.state.listEmails[indexItem].email}
                                                            onChange={(e) => this.onAddEmail(e, indexItem, item, true)}
                                                            inputProps={{
                                                                type: "email"
                                                            }}
                                                        />
                                                        <TextField variant="standard"
                                                            key={indexItem + "name"}
                                                            error={index === 0 && this.state.listEmails[indexItem].displayName === ""}
                                                            sx={{ flex: 1 }}
                                                            label={strings.displayName}
                                                            value={this.state.listEmails[indexItem].displayName}
                                                            onChange={(e) => this.onAddEmail(e, indexItem, item, false)}
                                                        />
                                                    </Stack>;
                                                })
                                            }
                                        </>
                                }
                                <Divider/>
                                <Typography variant="h6">{strings.languages}</Typography>
                                {
                                    this.state.listLanguages.map((item, index) => {
                                        const indexItem = this.state.listLanguages.indexOf(item);
                                        return <Stack spacing={2} direction="row" key={index}>
                                            <TextField variant="standard"
                                                sx={{ flex: 1 }}
                                                label={strings.languageName}
                                                value={this.state.listLanguages[indexItem].name}
                                                onChange={(e) => this.onEditLanguage(e.target.value, indexItem, "name")}
                                            />
                                            <TextField variant="standard"
                                                sx={{ width: 150 }}
                                                label={strings.languageCode}
                                                value={this.state.listLanguages[indexItem].code}
                                                onChange={(e) => this.onEditLanguage(e.target.value, indexItem, "code")}
                                            />
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={this.state.listLanguages[indexItem].checkedByDefault}
                                                        onChange={(e) => this.onEditLanguage(e.target.checked, indexItem, "checkedByDefault")}
                                                        value="isDisabled"
                                                        color="primary"
                                                    />
                                                }
                                                label={strings.languageCheckDefault}
                                            />
                                        </Stack>;
                                    })
                                }
                                <Divider/>
                                <Typography variant="h6">{strings.OrganizationParameters}</Typography>
                                {
                                    this.state.organizationParameters.map((item, index) => {
                                        const indexItem = this.state.organizationParameters.indexOf(item);
                                        return <Stack spacing={2} direction="row" key={index}>
                                            <TextField variant="standard"
                                                style={{ flex: 0.5 }}
                                                label={strings.parameterName}
                                                value={this.state.organizationParameters[indexItem].key}
                                                onChange={(e) => this.onEditOrgParameter(e.target.value, indexItem, "key")}
                                            />
                                            <TextField variant="standard"
                                                style={{ flex: 0.5 }}
                                                label={"Value"}
                                                value={this.state.organizationParameters[indexItem].value}
                                                onChange={(e) => this.onEditOrgParameter(e.target.value, indexItem, "value")}
                                            />
                                        </Stack>;
                                    })
                                }
                                <Divider/>
                                <Typography variant="h6">{strings.OrganizationFiles}</Typography>
                                {
                                    this.state.organizationFiles.map((item, index) => {
                                        const indexItem = this.state.organizationFiles.indexOf(item);
                                        return <Stack spacing={2} direction="row" key={index} alignItems="center">
                                            <TextField variant="standard"
                                                style={{ flex: 1 }}
                                                label={strings.parameterName}
                                                value={this.state.organizationFiles[indexItem].key}
                                                onChange={(e) => this.onEditOrgFile(e.target.value, indexItem, "key")}
                                            />
                                            <Button
                                                variant="contained" size="small"
                                                onClick={() => {
                                                    this.setState({
                                                        currentFileIndex: indexItem
                                                    });
                                                    this.fileInput.click();
                                                }}
                                            >
                                                {strings.chooseFile}
                                            </Button>
                                            <Typography>{this.state.organizationFiles[indexItem].value}</Typography>
                                        </Stack>;
                                    })
                                }
                                <input
                                    ref={(input) => { this.fileInput = input; }}
                                    type="file"
                                    onChange={ (e) => this.handleFileChange(e.target.files) }
                                    style={{ display: "none" }}
                                />
                                <Divider/>
                                <Typography variant="h6">{strings.displayParameters}</Typography>
                                {
                                    this.state.displayParameters.map((item, index) => {
                                        const indexItem = this.state.displayParameters.indexOf(item);
                                        return <Stack spacing={2} direction="row" key={index}>
                                            <TextField variant="standard"
                                                sx={{ flex: 0.5 }}
                                                label={strings.parameterName}
                                                value={this.state.displayParameters[indexItem].key}
                                                onChange={(e) => this.onEditDisplayParameter(e.target.value, indexItem, "key")}
                                            />
                                            <TextField variant="standard"
                                                sx={{ flex: 0.5 }}
                                                label={"Default value"}
                                                value={this.state.displayParameters[indexItem].defaultValue}
                                                onChange={(e) => this.onEditDisplayParameter(e.target.value, indexItem, "defaultValue")}
                                            />
                                        </Stack>;
                                    })
                                }
                                <Divider/>
                                <Typography variant="h6">{strings.compositionConfig}</Typography>
                                <Stack spacing={2} direction="row" sx={{ pl: 3 }}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={this.state.compIsVisible}
                                                onChange={(e) => this.setState({ compIsVisible: e.target.checked })}
                                                value="isDisabled"
                                                color="primary"
                                            />
                                        }
                                        label={strings.compositionIsVisibleLabel}
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={this.state.compPreview}
                                                onChange={(e) => this.setState({ compPreview: e.target.checked })}
                                                value="isDisabled"
                                                color="primary"
                                            />
                                        }
                                        label={strings.compositionPreviewLabel}
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={this.state.compDescription}
                                                onChange={(e) => this.setState({ compDescription: e.target.checked })}
                                                value="isDisabled"
                                                color="primary"
                                            />
                                        }
                                        label={strings.compositionDescriptionLabel}
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={this.state.compDescription2}
                                                onChange={(e) => this.setState({ compDescription2: e.target.checked })}
                                                value="isDisabled"
                                                color="primary"
                                            />
                                        }
                                        label={strings.compositionDescriptionLabel + " 2"}
                                    />
                                </Stack>
                                <Divider/>
                                <Typography variant="h6">{strings.compositionParameter}</Typography>
                                {
                                    this.state.compositionParameters.map((item, index) => {
                                        const indexItem = this.state.compositionParameters.indexOf(item);
                                        return <Stack spacing={2} direction="row" alignItems="center" key={index}>
                                            <TextField variant="standard"
                                                style={{ flex: 0.5 }}
                                                label={strings.parameterName}
                                                value={this.state.compositionParameters[indexItem].key}
                                                onChange={(e) => this.onEditParameter(e.target.value, indexItem, "key")}
                                            />
                                            <TextField variant="standard"
                                                style={{ flex: 0.5 }}
                                                label={strings.parameterDisplayName}
                                                value={this.state.compositionParameters[indexItem].displayName}
                                                onChange={(e) => this.onEditParameter(e.target.value, indexItem, "displayName")}
                                            />
                                            <TextField variant="standard"
                                                id="select-type"
                                                select
                                                label={strings.compositionType}
                                                sx={{ width: 150 }}
                                                value={this.state.compositionParameters[indexItem].type}
                                                onChange={(e) => this.onEditParameter(e.target.value, indexItem, "type")}
                                            >
                                                {types.map(option =>
                                                    <MenuItem key={option.key} value={option.key}>
                                                        {option.value}
                                                    </MenuItem>
                                                )}
                                            </TextField>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={this.state.compositionParameters[indexItem].isRequired}
                                                        onChange={(e) => this.onEditParameter(e.target.checked, indexItem, "isRequired")}
                                                        value="isRequired"
                                                        color="primary"
                                                    />
                                                }
                                                label={strings.isRequired}
                                                style={{ marginLeft: 10 }}
                                            />
                                        </Stack>;
                                    })
                                }
                                <Divider/>
                                {
                                    this.state.organizationId ?
                                        <Typography>{strings.compositionDefaultTree}</Typography>
                                        :
                                        <Typography>{strings.compositionDefaultTreeAvailable}</Typography>
                                }
                            </Stack>
                        </Paper>
                }
            </div>
        </div>;
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ActionsCreators, dispatch);
};

export default withRouter(connect(
    (state) => state,
    mapDispatchToProps
)(Organization));
